import React, { useState } from 'react';

export default function Accordion({ 
  items, 
  defaultOpen = null, 
  className = '',
  itemClassName = '',
  headerClassName = 'accordion-header',
  contentClassName = 'accordion-content',
  iconOpen = '▼',
  iconClosed = '▶',
  dark = false
}) {
  const [openIndex, setOpenIndex] = useState(defaultOpen);

  const toggleItem = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className={`space-y-2 ${dark ? 'accordion-dark' : ''} ${className}`}>
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        
        return (
          <div key={index} className={`border rounded-lg overflow-hidden ${dark ? 'border-[#404040] bg-[#2d2d2d]' : 'bg-white'} ${itemClassName}`}>
            <button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                toggleItem(index);
              }}
              className={`w-full text-left px-4 py-3 flex justify-between items-center hover:bg-gray-50 transition min-h-[52px] ${dark ? 'hover:bg-[#3a3a3a] text-white' : ''} ${headerClassName}`}
            >
              <div className="flex items-center gap-3">
                {item.icon && <span className="text-xl">{item.icon}</span>}
                <span className={`font-medium ${dark ? 'text-white' : 'text-gray-800'}`}>{item.title}</span>
                {item.badge !== undefined && item.badge !== null && item.badge !== '' && (
                  <span className={`ml-1 text-xs px-2 py-0.5 rounded-full ${dark ? 'bg-[#404040] text-white' : 'bg-gray-200 text-gray-700'}`}>
                    {item.badge}
                  </span>
                )}
              </div>
              <span className={`text-gray-400 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}>
                {isOpen ? iconOpen : iconClosed}
              </span>
            </button>
            
            <div className={`transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[2000px] opacity-100' : 'max-h-0 opacity-0'} overflow-hidden`}>
              <div className={`p-4 border-t ${dark ? 'border-[#404040] text-white' : ''} ${contentClassName}`}>
                {item.content}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
